;(function($){

    function ProvidersDocuments() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        if($("#modal-providers-documents").length > 0) {

            $("#modal-providers-documents").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();   
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-providers-documents" enctype="multipart/form-data">'+
                   '<div class="row">' +
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="title">Titulo</label>' +
                                '<input type="text" id="title" name="title">' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="total_hours">Carga Horária</label>' +
                                '<input type="text" id="total_hours" name="total_hours">' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="date">Válidade</label>' +
                                '<input type="date" id="date" name="date">' +
                            '</div>'+
                        '</div>'+                            
                   '</div>'+                   
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="file">Anexo</label>' +
                                '<div class="info">'+
                                    '<p>Para anexar mais de um arquivo, recomendamos arquivos .zip ou .rar</p>'+
                                '</div>'+
                                '<input type="file" id="file" name="file" data="upload">' +
                            '</div>'+
                        '</div>'+                             
                   '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<input type="hidden" id="providers_id" name="providers_id" value="'+_.providers_id+'">' +
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != ""){
                    $('#modal-providers-documents').iziModal('setTitle', 'Adicionar Documento');
                    $("#modal-providers-documents .content").html(_.html);

                    _.myForm = $("#form-providers-documents").validate({
                        rules: {
                            title: { required: true },
                            date: { required: true },
                            file: { required: true}
                        },
                        messages: {
                            title: { required: "Campo Obrigatório" },
                            date: { required: "Campo Obrigatório" },
                            file: { required: "Campo Obrigatório"}
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Preencha todos os campos.",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                        
                            $("#form-providers-documents .btn-send").html("Enviando...");
                            
                            $.ajax({
                                type: "POST",
                                url: _.API + "fornecedores/documento",
                                cache: false,
                                contentType: false,
                                processData: false,
                                data: new FormData(form),
                                success: function(result)
                                {
                                    $("#form-providers-documents .btn-send").html("Enviar");

                                    form.reset();

                                    $('#modal-providers-documents').iziModal('close'); 

                                    swal({
                                        title: result.message,
                                        text: "Click no botão para fechar!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: false
                                    }).then(function() {
                                      location = location+"#documentos";

                                      location.reload(true);
                                    });                                        
                                },
                                error: function(response) {
                                    var errors = $.parseJSON(response.responseText);
                                    
                                    swal({
                                        title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                        text: "Click no botão para fechar!",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: true
                                    });

                                   
                                    $myForm.showErrors(errors);
                                    
                                    $("#form-providers-documents .btn-send").html("Enviar");
                                }
                            });
                        }
                    });
                }                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.providers_id = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-providers-documents .content").html("");
                    $('#modal-providers-documents').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-create-providers-documents ").on("click", function(e){
            e.preventDefault();
            _.providers_id = $(this).data('provider');
            $('#modal-providers-documents').iziModal('open');           
        });

        if($("#modal-providers-documents-edit").length > 0) {

            $("#modal-providers-documents-edit").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();   
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-providers-documents-edit" enctype="multipart/form-data">'+
                   '<div class="row">' +
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="title">Titulo</label>' +
                                '<input type="text" id="title" name="title" value="'+_.title+'">' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="total_hours">Carga Horária</label>' +
                                '<input type="text" id="total_hours" name="total_hours" value="'+_.total_hours+'" data-personalizado>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="date">Válidade</label>' +
                                '<input type="date" id="date" name="date" value="'+_.date+'">' +
                            '</div>'+
                        '</div>'+                            
                   '</div>'+                   
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="file">Anexo</label>' +
                                '<div class="info">'+
                                    '<p>Para anexar mais de um arquivo, recomendamos arquivos .zip ou .rar</p>'+
                                '</div>'+
                                '<input type="file" id="file" name="file" data="upload">' +
                            '</div>'+
                        '</div>'+                             
                   '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<input type="hidden" id="providers_id" name="providers_documents_id" value="'+_.providers_id+'">' +
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != ""){
                    $('#modal-providers-documents-edit').iziModal('setTitle', 'Editar Documento');
                    $("#modal-providers-documents-edit .content").html(_.html);

                    _.myForm = $("#form-providers-documents-edit").validate({
                        rules: {
                            title: { required: true },
                            date: { required: true }
                        },
                        messages: {
                            title: { required: "Campo Obrigatório" },
                            date: { required: "Campo Obrigatório" }
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Preencha todos os campos.",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                        
                            $("#form-providers-documents-edit .btn-send").html("Enviando...");
                            
                            $.ajax({
                                type: "POST",
                                url: _.API + "fornecedores/documento/editar/"+_.providers_id,
                                cache: false,
                                contentType: false,
                                processData: false,
                                data: new FormData(form),
                                success: function(result)
                                {
                                    $("#form-providers-documents-edit .btn-send").html("Enviar");

                                    form.reset();

                                    $('#modal-providers-documents-edit').iziModal('close'); 

                                    swal({
                                        title: result.message,
                                        text: "Click no botão para fechar!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: false
                                    }).then(function() {
                                      location = location+"#documentos";

                                      location.reload(true);
                                    });                                        
                                },
                                error: function(response) {
                                    var errors = $.parseJSON(response.responseText);
                                    
                                    swal({
                                        title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                        text: "Click no botão para fechar!",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: true
                                    });

                                   
                                    $myForm.showErrors(errors);
                                    
                                    $("#form-providers-documents-edit .btn-send").html("Enviar");
                                }
                            });
                        }
                    });
                }                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.providers_id = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-providers-documents-edit .content").html("");
                    $('#modal-providers-documents-edit').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-edit-providers-documents ").on("click", function(e){
            e.preventDefault();
            _.providers_id = $(this).data('provider-document'); 
            _.title = $(this).data('provider-title'); 
            _.date = $(this).data('provider-date'); 
            _.total_hours = $(this).data('provider-total-hours');  
            $('#modal-providers-documents-edit').iziModal('open');           
        });
    }  
     

   	new ProvidersDocuments();

}(jQuery));